// components/industry-templates/FashionEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Sparkles, Users, Calendar, ShoppingBag } from 'lucide-react';

export const FashionEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Runway Shows */}
      {industryData?.runway_shows && (
        <Card className="border-0 bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Sparkles className="w-8 h-8" style={{ color: theme.primary }} />
              Runway Shows
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {industryData.runway_shows.map((show: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <h3 className="text-xl font-bold text-white">{show.designer}</h3>
                      <p className="text-slate-300">{show.collection}</p>
                    </div>
                    <Badge style={{ backgroundColor: theme.primary }}>{show.time}</Badge>
                  </div>
                  {show.models && (
                    <p className="text-sm text-slate-400">Models: {show.models}</p>
                  )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Designers */}
      {industryData?.designers && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Users className="w-6 h-6" style={{ color: theme.primary }} />
              Featured Designers
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {industryData.designers.map((designer: string, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg text-center border border-white/10 hover:scale-105 transition-transform">
                  <p className="text-white font-medium">{designer}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Shopping */}
      {industryData?.shopping && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <ShoppingBag className="w-6 h-6" style={{ color: theme.primary }} />
              Shopping Experience
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-white/5 rounded-lg p-4">
              <p className="text-white mb-3">Exclusive designer pop-up stores with special discounts</p>
              {industryData.shopping.discounts && (
                <Badge className="bg-yellow-500 text-black text-lg py-2 px-4">
                  Up to {industryData.shopping.discounts} OFF
                </Badge>
              )}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
